function closePopover(event) {
    var popover = document.querySelector('details[data-popover]');
    if (popover && !popover.contains(event.target)) {
        popover.removeAttribute('open');
    }
}

document.addEventListener('click', closePopover);
document.addEventListener('touchend', closePopover);